import React from 'react';
import { useTranslation } from 'react-i18next';

import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import CircularProgress from '@material-ui/core/CircularProgress';
import TableContainer from '@material-ui/core/TableContainer';

import useStyles from './styles';

const Pagination = ({ emptyData, loading, columns, size, children }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Paper className={classes.root}>
      <TableContainer>
      <Table stickyHeader size={size}>
        <TableHead>
          <TableRow>
            {columns}
          </TableRow>
        </TableHead>
        <TableBody>
          {loading && (
            <TableRow key="loading">
              <TableCell align="center" colSpan={100}>
                {/* {t('table.loading')} */}
                <CircularProgress />
              </TableCell>
            </TableRow>
          )}
          {!loading && emptyData && (
            <TableRow key="empty">
              <TableCell align="center" colSpan={100}>
                {t('table.emptyDataSource')}
              </TableCell>
            </TableRow>
          )}
          {!loading && !emptyData && <>{children}</>}
        </TableBody>
      </Table>
      </TableContainer>
    </Paper>
  );
};

export default Pagination;
